import React, { ReactNode, createContext, useReducer, useContext } from "react";
import { sanaBaseUrl } from "../constants";

// types
type Action =
  | { type: "SET_VIDEO"; selfieVideo: Blob | null }
  | { type: "SET_SIGN"; signature: string, officeCode: string }
  | { type: "SET_SELIFIE_IMAGE"; selfieImg: string }
  | {
    type: "SET_REQ_INFO";
    selfieText: string;
    selfieHeadDirec: any[];
  }
  | { type: "SET_TIMEOUT" }
  | { type: "REMOVE_TIMEOUT" }
  | { type: "CLEAR_STATE" }
  | { type: "SET_POSITION_INFO"; positionInfo: PositionsInfo };

export type PositionsInfo = {
  screenWidth: number;
  screenHeight: number;
  fromTop: number;
  fromLeft: number;
  width: number;
  height: number;
};

type Dispatch = (action: Action) => void;
type State = {
  selfieVideo: Blob | null;
  signature: string;
  selfieImg: string;
  token: string;
  returnUrl: string;
  requestNo: string;
  selfieText: string;
  selfieHeadDirec: any[];
  uniqueId: string;
  timeout: number;
  positionInfo: PositionsInfo | null;
  officeCode: string | '';
};
type AuthProviderProps = { children: ReactNode };

const AuthStateContext = createContext<State | undefined>(undefined);
const AuthDispatchContext = createContext<Dispatch | undefined>(undefined);
const initState: State = {
  selfieVideo: null,
  signature: "",
  selfieImg: "",
  token: "",
  returnUrl: "",
  requestNo: "",
  selfieText: "",
  selfieHeadDirec: [],
  uniqueId: "",
  timeout: 0,
  positionInfo: null,
  officeCode: "",
};

// reducer
function authReducer(state: State, action: Action) {
  switch (action.type) {
    case "SET_VIDEO": {
      return { ...state, selfieVideo: action.selfieVideo };
    }
    case "SET_SIGN": {
      return { ...state, signature: action.signature, officeCode: action.officeCode };
    }
    case "SET_SELIFIE_IMAGE": {
      return { ...state, selfieImg: action.selfieImg };
    }
    case "SET_REQ_INFO": {
      return {
        ...state,
        selfieText: action.selfieText,
        selfieHeadDirec: action.selfieHeadDirec,
      };
    }
    case "SET_TIMEOUT": {
      return {
        ...state,
        // timeout: window.setTimeout(() => {
        //   window.location.href = sanaBaseUrl;
        // }, 10 * 60 * 1000),
      };
    }
    case "REMOVE_TIMEOUT": {
      window.clearTimeout(state.timeout);
      return { ...state, timeout: 0 };
    }
    case "SET_POSITION_INFO": {
      return { ...state, positionInfo: action.positionInfo };
    }
    case "CLEAR_STATE": {
      return initState;
    }
    default: {
      throw new Error(`Unhandled action type`);
    }
  }
}

// provider
function AuthProvider({ children }: AuthProviderProps) {
  const [state, dispatch] = useReducer(authReducer, initState);
  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
}

function useAuthState() {
  const context = useContext(AuthStateContext);
  if (context === undefined) {
    throw new Error("useAuthState must be used within a AuthProvider");
  }
  return context;
}

function useAuthDispatch() {
  const context = useContext(AuthDispatchContext);
  if (context === undefined) {
    throw new Error("useAuthDispatch must be used within a AuthProvider");
  }
  return context;
}

// actions

export { AuthProvider, useAuthState, useAuthDispatch };
